(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dinner-box-addons"] && !Shopify.designMode) return;
  try {
    import('@theme/component').then(({ Component }) => {
  class DinnerBoxAddons extends Component {
    connectedCallback() {
      super.connectedCallback();
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.messages = JSON.parse(this.querySelector('[data-messages]').textContent);
      this.roast = this.querySelector('[data-roast]');
      this.steaksToggle = this.querySelector('[data-steaks-toggle]');
      this.steaks = Array.from(this.querySelectorAll('[data-steak]'));
      this.error = this.querySelector('[data-error]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.addEventListener('change', () => this.refresh(), { signal });
      const section = this.closest('.shopify-section');
      this.form = section?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] form`);
      if (!this.form) return;
      this.roast.disabled = false;
      this.steaksToggle.disabled = false;
      this.form.addEventListener('change', () => this.refresh(), { signal });
      this.form.addEventListener('input', () => this.refresh(), { signal });
      window.addEventListener('click', event => {
        const button = event.target instanceof Element ? event.target.closest('button, input[type="submit"]') : null;
        if (button?.form === this.form && button.type === 'submit') this.submit(event);
      }, { capture: true, signal });
      window.addEventListener('submit', event => {
        if (event.target === this.form) this.submit(event);
      }, { capture: true, signal });
      this.refresh();
    }
    disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); this.controller = null; }
    updatedCallback() { super.updatedCallback(); this.controller?.abort(); this.controller = null; this.connectedCallback(); }
    quantity() { return Math.max(1, Number(this.form?.querySelector('[name="quantity"]')?.value) || 1); }
    choices() {
      const fields = [this.roast, ...(this.steaksToggle.checked ? this.steaks : [])];
      return fields.filter(field => field.value).map(field => field.selectedOptions[0]);
    }
    refresh() {
      const enabled = this.steaksToggle.checked;
      this.querySelector('[data-steaks-fields]').hidden = !enabled;
      this.steaks.forEach(field => { field.disabled = !enabled; field.required = enabled; });
      const cents = Number(this.dataset.basePrice) + this.choices().reduce((sum, option) => sum + Number(option.dataset.price), 0);
      this.querySelector('[data-total]').textContent = this.money.format(cents * this.quantity() / 100);
      this.error.hidden = true;
    }
    showError(message) { this.error.textContent = message; this.error.hidden = false; this.error.scrollIntoView({ block: 'nearest' }); }
    async cartRequest(path, data) {
      const response = await fetch(window.Shopify.routes.root + path, data ? { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) } : { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' });
      const result = await response.json();
      return { ok: response.ok && !result.status, result };
    }
    async removeAttempt(group) {
      const current = await this.cartRequest('cart.js');
      if (!current.ok) throw new Error(this.messages.reviewCart);
      const updates = Object.fromEntries(current.result.items.filter(item => item.properties?._dinner_box_group === group).map(item => [item.key, 0]));
      if (Object.keys(updates).length) {
        const removed = await this.cartRequest('cart/update.js', { updates });
        if (!removed.ok || removed.result.items.some(item => item.properties?._dinner_box_group === group)) throw new Error(this.messages.reviewCart);
      }
    }
    async submit(event) {
      if (event.defaultPrevented) return;
      if (!this.roast.value && !this.steaksToggle.checked) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      if (this.steaksToggle.checked && this.steaks.some(field => !field.value)) { this.showError(this.messages.selectTwo); this.steaks.find(field => !field.value)?.focus(); return; }
      if (!this.form.reportValidity()) return;
      const quantity = this.quantity();
      const data = new FormData(this.form);
      const plan = data.get('selling_plan') || this.dataset.basePlan;
      const choices = this.choices();
      if (!plan || choices.some(option => !option.dataset.plan)) { this.showError(this.messages.preorderError); return; }
      const group = crypto.randomUUID();
      const properties = {};
      const attributes = {};
      for (const [key, value] of data.entries()) {
        if (typeof value !== 'string') continue;
        const property = key.match(/^properties\[(.+)\]$/);
        const attribute = key.match(/^attributes\[(.+)\]$/);
        if (property) properties[property[1]] = value;
        if (attribute) attributes[attribute[1]] = value;
      }
      properties._dinner_box_group = group;
      properties[this.messages.roastChoice] = this.roast.value ? this.roast.selectedOptions[0].dataset.title : this.messages.none;
      properties[this.messages.steakChoices] = this.steaksToggle.checked ? this.steaks.map(field => field.selectedOptions[0].dataset.title).join(' + ') : this.messages.none;
      const items = [{ id: Number(this.dataset.baseId), quantity, selling_plan: Number(plan), properties }];
      const stock = new Map([[Number(this.dataset.baseId), Number(this.dataset.baseStock)]]);
      for (const option of choices) {
        const id = Number(option.value);
        stock.set(id, Number(option.dataset.stock));
        const existing = items.find(item => item.id === id);
        if (existing) existing.quantity += quantity;
        else items.push({ id, quantity, selling_plan: Number(option.dataset.plan), properties: { _dinner_box_group: group, [this.messages.addonFor]: 'Dinner Box' } });
      }
      this.busy = true;
      const buttons = Array.from(this.form.querySelectorAll('[type="submit"]')).map(button => ({ button, disabled: button.disabled }));
      buttons.forEach(({ button }) => { button.disabled = true; });
      this.error.textContent = this.messages.adding;
      this.error.hidden = false;
      let attempted = false;
      try {
        const current = await this.cartRequest('cart.js');
        if (!current.ok) throw new Error(this.messages.cartError);
        const pickup = { ...current.result.attributes, ...attributes };
        if (!pickup['Pickup Location'] || !pickup['Pickup Date']) throw new Error(this.messages.pickupError);
        for (const item of items) {
          const already = current.result.items.filter(line => line.variant_id === item.id).reduce((sum, line) => sum + line.quantity, 0);
          if (item.quantity + already > stock.get(item.id)) throw new Error(this.messages.stockError);
        }
        if (Object.keys(attributes).length) {
          const savedPickup = await this.cartRequest('cart/update.js', { attributes });
          if (!savedPickup.ok) throw new Error(this.messages.cartError);
        }
        attempted = true;
        const added = await this.cartRequest('cart/add.js', { items });
        if (!added.ok) throw new Error(added.result.description || this.messages.cartError);
        const verified = await this.cartRequest('cart.js');
        if (!verified.ok || !items.every(item => verified.result.items.filter(line => line.variant_id === item.id && line.properties?._dinner_box_group === group && line.selling_plan_allocation?.selling_plan?.id === item.selling_plan).reduce((sum, line) => sum + line.quantity, 0) === item.quantity)) throw new Error(this.messages.cartError);
        window.location.assign(window.Shopify.routes.root + 'cart');
      } catch (error) {
        let message = error.message || this.messages.cartError;
        if (attempted) { try { await this.removeAttempt(group); } catch { message = this.messages.reviewCart; } }
        this.showError(message);
        this.busy = false;
        buttons.forEach(({ button, disabled }) => { button.disabled = disabled; });
      }
    }
  }
  if (!customElements.get('dinner-box-addons')) customElements.define('dinner-box-addons', DinnerBoxAddons);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["holiday-feast-flavors"] && !Shopify.designMode) return;
  try {
    import('@theme/component').then(({ Component }) => {
    const choices = new Map();
    class HolidayFeastFlavors extends Component {
      connectedCallback() {
        super.connectedCallback();
        this.connectChoices();
      }
      connectChoices() {
        this.controller?.abort();
        this.controller = new AbortController();
        const key = this.dataset.productId;
        const previous = choices.get(key) || {};
        for (const field of this.querySelectorAll('select')) {
          if (previous[field.name] && Array.from(field.options).some(option => option.value === previous[field.name])) field.value = previous[field.name];
        }
        this.addEventListener('change', () => {
          choices.set(key, Object.fromEntries(Array.from(this.querySelectorAll('select'), field => [field.name, field.value])));
        }, { signal: this.controller.signal });
      }
      updatedCallback() {
        super.updatedCallback();
        this.connectChoices();
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this.controller?.abort();
      }
    }
    if (!customElements.get('holiday-feast-flavors')) customElements.define('holiday-feast-flavors', HolidayFeastFlavors);
  });
  } catch(e) { console.error(e); }
})();

})();
